/**
 * e-Tesa — Buton discret (rotiță) pentru re-etichetarea monedei devizului
 * fără conversie. Folosit când admin a introdus prețurile deja în moneda
 * dorită dar toggle-ul era pe cealaltă. Setează cursul la 1.0 → valorile
 * NU se modifică, doar eticheta.
 *
 * Extras din DevizTab.jsx (refactor Etapa 1A).
 */

import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { Settings } from "lucide-react";
import { toast } from "sonner";

export default function CurrencyRelabelMenu({ setCurrency, setExchangeRate }) {
  const relabel = (code) => {
    setCurrency(code);
    setExchangeRate(1);
    toast.success(`Devizul este acum etichetat ca ${code} (valorile nu s-au modificat).`);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="ml-1 p-1.5 rounded text-slate-400 hover:text-slate-700 hover:bg-slate-200 transition"
          title="Schimbă doar eticheta monedei (fără recalculare)"
          data-testid="currency-relabel-menu"
        >
          <Settings className="w-3.5 h-3.5" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-72">
        <div className="px-2 py-1.5 text-[11px] text-slate-500 border-b">
          Schimbă <strong>doar eticheta monedei</strong>, fără să recalculezi prețurile.
          Folosește când valorile sunt deja introduse în moneda dorită.
        </div>
        <DropdownMenuItem
          onClick={() => relabel("RON")}
          data-testid="currency-relabel-ron"
          className="cursor-pointer"
        >
          <span className="inline-block w-8 text-center font-bold text-teal-700">RON</span>
          <span className="text-xs text-slate-600">Re-etichetează ca RON</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => relabel("EUR")}
          data-testid="currency-relabel-eur"
          className="cursor-pointer"
        >
          <span className="inline-block w-8 text-center font-bold text-teal-700">EUR</span>
          <span className="text-xs text-slate-600">Re-etichetează ca EUR</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
